import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import { Translation } from '@morningtrain/react-translations'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function ScheduleTitle () {
  const category = useValue('category')

  if (!category) {
    return null
  }

  return (
    <>
      <Translation name={['generic', category].join('.')} />
      <span> </span>
      <span className='lowercase'>
        <Translation name='generic.week' />
      </span>
      <span> </span>
      <span className='lowercase'>
        <Displays.Date name='start_at' dateFormat='WW' />
      </span>
    </>
  )
}

export default observer(ScheduleTitle)
